import React from "react";

export function Icon({children, ...props}) {
    return (
        <i {...props}  className={'material-icons ' + props.className}>{children}</i>
    )
}
